import type { ReactNode } from "react";

/** Grey summary panel at the foot of the review box. Also used by the
 *  payment-success screens. */
export function PaymentsSummaryBox({ children }: { children: ReactNode }) {
  return (
    <div className="flex w-full flex-col gap-[5px] rounded-[9px] bg-secondary p-[15px] text-content-muted">
      {children}
    </div>
  );
}
